module.exports = __webpack_public_path__ + "static/img/sicbo_en.6ec0f02.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/sa/sicbo_en.png
// module id = fBcV
// module chunks = 1